import { render, staticRenderFns } from "./AuthHeader.vue?vue&type=template&id=49553142&"
import script from "./AuthHeader.vue?vue&type=script&lang=ts&"
export * from "./AuthHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports